// PIN FIREBASE'S OPTIONAL DEFAULTS BEFORE THE SDK LOADS.
//
// The Firebase JS SDK looks for optional defaults in a global, then an
// environment variable, then a `__FIREBASE_DEFAULTS__` cookie, and takes the
// first it finds. In firebase < 10.9.0 (this page ships 9.23.0, because
// gcip-iap 2.0.1 requires firebase ^9.8.3) one of those defaults is
// `_authTokenSyncURL`, and a cookie planted from another subdomain could point
// it at a host that then receives the user's ID tokens. The advisory is
// GHSA-3wf4-68gx-mph8.
//
// This page passes its Firebase configuration explicitly and uses none of
// those defaults, so it pins the global to an empty, frozen object. The global
// is consulted first, so the cookie is never read. `client.js` imports this
// module before anything from Firebase.
export function pinFirebaseDefaults(target = globalThis) {
  try {
    Object.defineProperty(target, '__FIREBASE_DEFAULTS__', {
      value: Object.freeze({}), writable: false, configurable: false, enumerable: false
    });
  } catch {
    // Already pinned (the property is non-configurable): nothing to do.
  }
  return target.__FIREBASE_DEFAULTS__;
}

pinFirebaseDefaults();
